export const normalizeList = (data) => {
  if (!data) return [];
  return Array.isArray(data) ? data : Object.values(data);
};

export const normalizeLogList = (data) => {
  return normalizeList(data).map(l => {
    const norm = {
      ...l,
      type: l.type || l.action_type || '',
      slipNo: l.slipNo || l.voucher_no || l.slip || '',
      unitPrice: l.unitPrice ?? l.unit_price ?? 0,
      qty: l.qty ?? l.quantity ?? 0,
      partner: l.partner || l.customer || '',
      date: l.date || ''
    };
    // Strip undefined values — Firebase rejects them
    for (const key of Object.keys(norm)) {
      if (norm[key] === undefined) delete norm[key];
    }
    return norm;
  });
};

export const normalizeCustomerList = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  return Object.entries(data).map(([id, c]) => ({ id, ...c }));
};

export const toCustomerMap = (list) => {
  const map = {};
  (list || []).forEach((c, idx) => {
    // Support both legacy CUST_XXXX and new EMH-XXXXX ID formats
    const id = c.id || c.emhId || c.customer_id || `CUST_${String(idx + 1).padStart(4, '0')}`;
    const clean = { ...c };
    delete clean.id;
    map[id] = clean;
  });
  return map;
};
